import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('commissions.configurations.routes.index'),
        name: i18n.t('commissions.configurations.routes.index'),
        component: () =>
            import(
                /* webpackChunkName: "commissions.configurations" */ '@/views/commissions/configurations/Index.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t(
                        'commissions.configurations.breadcrumbs.index',
                    ),
                    to: {
                        name: i18n.t('commissions.configurations.routes.index'),
                    },
                    disable: true,
                },
            ],
        },
        props: true,
    },
    {
        path: '/' + i18n.t('commissions.configurations.routes.edit') + '/:id',
        name: i18n.t('commissions.configurations.routes.edit'),
        component: () =>
            import(
                /* webpackChunkName: "commissions.configurations" */ '@/views/commissions/configurations/Edit.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t(
                        'commissions.configurations.breadcrumbs.index',
                    ),
                    to: {
                        name: i18n.t('commissions.configurations.routes.index'),
                    },
                    disable: false,
                },
                {
                    text: i18n.t('commissions.configurations.breadcrumbs.edit'),
                    to: {
                        name: i18n.t('commissions.configurations.routes.edit'),
                    },
                    disable: true,
                },
            ],
        },
        props: true,
    },
]
